import WebApp from '@twa-dev/sdk';

export const closeWebapp = (): void => {
  WebApp?.close?.();
};
